import { VisaTinkCompleteTokenization } from "../../components/CheckoutComponent/VisaTinkCompleteTokenization";
import { useSearchParams } from "react-router-dom";
import { LoadingSpinner } from "../AddUserPage/AddUser";
import { paymentCallbackError } from "../../store/nanostore";
import { useStore } from "@nanostores/react";
import ErrorComponent from "../../components/NotFound";
import React from "react";

export const PaymentCallback = () => {
  const [params] = useSearchParams();
  const $paymentCallbackError = useStore(paymentCallbackError);

  const accountVerificationReportId = params.get(
    "account_verification_report_id"
  );
  const state = JSON.parse(params.get("state") || "{}");

  const url = new URL(state.returnUrl);
  url.searchParams.append("state", params.get("state") || "");
  // window.location.href = url.toString()
  const renderComponent = () => {
    state.url = url;
    if (accountVerificationReportId) {
      return (
        <VisaTinkCompleteTokenization
          providerCode={accountVerificationReportId}
          state={state}
        />
      );
    }
  };
  if ($paymentCallbackError) {
    return (
      <ErrorComponent
        route={state.returnUrl}
        routeText={"Return to Payment"}
        type={"Payment"}
        title={"Oops! Error Processing Payment"}
      />
    );
  }
  return (
    <div>
      <LoadingSpinner />
      {renderComponent()}
    </div>
  );
};
